export const copyToClipboard = async (text) => {
  const raw = String(text ?? '');
  if (!raw) return false;

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(raw);
      return true;
    }
  } catch (_) {
    // fall back
  }

  try {
    const el = document.createElement('textarea');
    el.value = raw;
    el.setAttribute('readonly', '');
    el.style.position = 'fixed';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    return true;
  } catch (_) {
    return false;
  }
};
